var render, staticRenderFns
import script from "./BarGraph.vue?vue&type=script&lang=js&"
export * from "./BarGraph.vue?vue&type=script&lang=js&"
import style0 from "./BarGraph.vue?vue&type=style&index=0&id=3267ef46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3267ef46",
  null
  
)

export default component.exports